import { Parametro } from '../../service-base/parametro';

export class Filtros {

    filtros: Parametro[];

    constructor() {
        this.filtros = [];
    }
}
